(() => {
  document.querySelectorAll('[data-sam-form]').forEach((root) => {
    const form = root.querySelector('[data-sam-form-element]');
    if (!form) return;
    const steps = Array.from(root.querySelectorAll('[data-sam-step]'));
    const prev = root.querySelector('[data-sam-prev]');
    const next = root.querySelector('[data-sam-next]');
    const submit = root.querySelector('[data-sam-submit]');
    const bar = root.querySelector('[data-sam-progress-bar]');
    const currentText = root.querySelector('[data-sam-progress-current]');
    const totalText = root.querySelector('[data-sam-progress-total]');
    const status = root.querySelector('[data-sam-form-status]');
    const success = root.querySelector('[data-sam-success]');
    let current = 0;
    if (totalText) totalText.textContent = String(steps.length);

    const conditionalSelects = root.querySelectorAll('[data-conditional-select]');
    const updateConditionals = () => {
      conditionalSelects.forEach((select) => {
        const key = select.dataset.conditionalSelect;
        root.querySelectorAll(`[data-conditional-target="${key}"]`).forEach((target) => {
          const values = (target.dataset.showWhen || '').split('|');
          target.hidden = !values.includes(select.value);
        });
      });
    };
    conditionalSelects.forEach((select) => select.addEventListener('change', updateConditionals));
    updateConditionals();

    const showStep = (index) => {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, i) => { step.hidden = i !== current; });
      if (prev) prev.hidden = current === 0;
      if (next) next.hidden = current === steps.length - 1;
      if (submit) submit.hidden = current !== steps.length - 1;
      if (currentText) currentText.textContent = String(current + 1);
      if (bar) bar.style.width = `${((current + 1) / steps.length) * 100}%`;
      status.textContent = '';
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const validateStep = () => {
      const fields = Array.from(steps[current].querySelectorAll('input, select, textarea')).filter((field) => !field.closest('[hidden]'));
      for (const field of fields) {
        if (!field.checkValidity()) {
          field.reportValidity();
          field.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }
      return true;
    };

    next?.addEventListener('click', () => { if (validateStep()) showStep(current + 1); });
    prev?.addEventListener('click', () => showStep(current - 1));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!validateStep()) return;
      const accessKey = form.querySelector('input[name="access_key"]')?.value?.trim();
      if (!accessKey) {
        status.textContent = 'Falta configurar la clave de Web3Forms en esta sección.';
        return;
      }
      submit.disabled = true;
      submit.textContent = 'Enviando…';
      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.message || 'No fue posible enviar el formulario.');
        form.hidden = true;
        success.hidden = false;
        success.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        status.textContent = 'No pude enviar el formulario. Intenta nuevamente en unos minutos.';
        submit.disabled = false;
        submit.textContent = 'Enviar formulario';
      }
    });

    showStep(0);
  });
})();